import ActivatePage from '@/pages/activate/activate-page';
import Admin from '@/pages/admin/admin-page';
import ApiProvidersPage from '@/pages/api-providers/api-providers-page';
import ChangePasswordPage from '@/pages/change-password/change-password-page';
import ChangePasswordSuccess from '@/pages/change-password/change-password-success';
import ChatPage from '@/pages/chat-page/chat-page';
import CohortsPage from '@/pages/cohorts/cohorts-page';
import DashboardPage from '@/pages/dashboard/dashboard-page';
import DiscoverPage from '@/pages/discover/discover-page';
import DocumentDraftPage from '@/pages/editor/document-draft-page';
import EvaluationsPage from '@/pages/evaluations/evaluations-page';
import ApplicationLayout from '@/pages/layout/application-layout';
import LearningPathBuilder from '@/pages/learning-paths/learning-path-builder';
import LearningPathsPage from '@/pages/learning-paths/learning-paths-page';
import NotFound from '@/pages/not-found';
import NewPractice from '@/pages/practice/new-practice';
import Practices from '@/pages/practice/practices';
import SearchPage from '@/pages/search/search-page';
import UserProfiles from '@/pages/user-profile/user-profiles';
import CreateUser from '@/pages/users/components/create-user';
import VariablesPage from '@/pages/variables/variables';
import { isSoulMapMode } from '@/utils/app-mode';
import { LegacyDashboardRedirect } from '@/routes/legacy-dashboard-redirect';
import Playground from 'Components/playground';
import AgentPage from 'Src/pages/agent/agent-page';
import VisualizeAgent from 'Src/pages/agent/visualize-agent';
import DocumentsPage from 'Src/pages/documents';
import DocumentReorderPage from 'Src/pages/documents/document-reorder-page';
import {
  CheckEmailPage,
  ForgotPasswordPage,
  ResetPasswordPage,
} from 'Src/pages/forgot-password';
import DashboardContent from 'Src/pages/layout/components/dashboard-content';
import Dashboard from 'Src/pages/layout/dashboard';
import LibraryPage from 'Src/pages/library/library-page';
import LiftLoginPage from 'Src/pages/login/lift-login-page';
import SoulMapLoginPage from 'Src/pages/login/soulmap-login-page';
import TeamsAuthStartPage from 'Src/pages/login/teams-auth-start-page';
import PlaygroundPage from 'Src/pages/playground/playground-page';
import SoulMapHomePage from 'Src/pages/soulmap/soulmap-home-page';
import TabsPage from 'Src/pages/tenant-config/tabs-page';
import TenantConfigBuilder from 'Src/pages/tenant-config/tenant-config-builder';
import TenantConfigPage from 'Src/pages/tenant-config/tenant-config-page';
import UsersPage from 'Src/pages/users/users-page';

export const liftRouteConfig = [
  {
    path: 'login',
    element: <LiftLoginPage />,
    isPublic: true,
  },
  {
    path: 'soulmap-login',
    element: <SoulMapLoginPage />,
    isPublic: true,
  },
  {
    path: 'teams-auth-start',
    element: <TeamsAuthStartPage />,
    isPublic: true,
  },
  {
    path: 'activate',
    element: <ActivatePage />,
    isPublic: true,
  },
  {
    path: 'activate/:token',
    element: <ActivatePage />,
    isPublic: true,
  },
  {
    path: 'forgot-password',
    element: <ForgotPasswordPage />,
    isPublic: true,
  },
  {
    path: 'forgot-password/check-email',
    element: <CheckEmailPage />,
    isPublic: true,
  },
  {
    path: 'forgot-password/reset/:token',
    element: <ResetPasswordPage />,
    isPublic: true,
  },
  {
    path: 'change-password-success',
    element: <ChangePasswordSuccess />,
    isPublic: true,
  },
  {
    path: 'home',
    element: <Dashboard />,
    isPublic: false,
    children: [
      {
        path: '',
        element: <DashboardContent />,
      },
      { path: ':id/run', element: <ChatPage /> },
      { path: 'change-password', element: <ChangePasswordPage /> },
    ],
  },
  {
    path: 'dashboard',
    element: <Dashboard />,
    isPublic: false,
    children: [
      { path: '', element: <DashboardPage /> },
      // Home used to live at /dashboard; keep old chat and change-password links working.
      { path: ':id/run', element: <LegacyDashboardRedirect /> },
      { path: 'change-password', element: <LegacyDashboardRedirect /> },
    ],
  },
  {
    path: 'practices',
    element: <Dashboard />,
    isPublic: false,
    children: [
      { path: ':id/run', element: <ChatPage /> },
      {
        path: 'users/:userId',
        element: <Practices title={'Practice History'} />,
      },
    ],
  },
  {
    path: 'library',
    element: <Dashboard />,
    isPublic: false,
    children: [
      {
        path: '',
        element: <LibraryPage />,
      },
    ],
  },
  {
    path: 'discover',
    element: <Dashboard />,
    isPublic: false,
    children: [
      {
        path: '',
        element: <DiscoverPage />,
      },
    ],
  },
  {
    path: 'soulmap',
    element: <Dashboard />,
    isPublic: false,
    children: [
      {
        path: '',
        element: <SoulMapHomePage />,
      },
      { path: ':id/run', element: <ChatPage /> },
    ],
  },
  {
    path: 'search',
    element: <Dashboard />,
    isPublic: false,
    children: [
      {
        path: '',
        element: <SearchPage />,
      },
    ],
  },

  // {
  //   path: '/practice-history',
  //   element: <Dashboard />,
  //   isPublic: false,
  //   isAdmin: false,
  //   children: [
  //     {
  //       path: 'users/:userId',
  //       element: <Practices title={'Practice History'} />,
  //       children: [{ path: ':id/run', element: <ChatPage /> }],
  //     },
  //     {
  //       path: ':id/run',
  //       element: <ChatPage />,
  //     },
  //   ],
  // },

  {
    path: '',
    element: <ApplicationLayout />,
    isPublic: false,
    isAdmin: true,
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            element: <ChatPage />,
          },
          { path: ':id/run', element: <ChatPage /> },
        ],
      },
      //   { path: 'lift-coach', element: <ChatPage /> },
      {
        path: 'lift-coach',
        children: [
          {
            path: '',
            element: <ChatPage />,
          },
          { path: ':id/run', element: <ChatPage /> },
        ],
      },
      {
        path: 'leadership-gym',
        children: [
          {
            path: '',
            element: <NewPractice title={'Leadership Gym'} tag="Action" />,
          },
          { path: ':id/run', element: <ChatPage /> },
        ],
      },
      {
        path: 'campaigns',
        children: [
          {
            path: '',
            element: <NewPractice title={'Campaigns'} tag="campaign" />,
          },
          { path: ':id/run', element: <ChatPage /> },
        ],
      },
      {
        path: 'documents',
        children: [
          { path: '', element: <DocumentsPage /> },
          { path: 'reorder', element: <DocumentReorderPage /> },
          { path: ':id/draft', element: <DocumentDraftPage /> },
        ],
      },
      {
        path: 'agents',
        children: [
          { path: '', element: <Admin /> },
          { path: 'create', element: <AgentPage /> },
          { path: ':id/visualize', element: <VisualizeAgent /> },
          { path: ':id/edit', element: <AgentPage /> },
        ],
      },
      {
        path: 'practice-history',
        children: [
          { path: '', element: <Practices title={'Practice History'} /> },
          { path: ':id/run', element: <ChatPage /> },
        ],
      },
      {
        path: 'user-profiles',
        children: [
          { path: '', element: <UserProfiles /> },
          { path: ':id/run', element: <ChatPage /> },
        ],
      },
      {
        path: 'users',
        children: [
          { path: '', element: <UsersPage /> },
          { path: 'create', element: <CreateUser /> },
        ],
      },
      { path: 'ai-providers', element: <ApiProvidersPage /> },
      { path: 'evaluations', element: <EvaluationsPage /> },
      { path: 'playground', element: <Playground /> },
      { path: 'evaluations/playground/new', element: <PlaygroundPage /> },
      {
        path: 'variables',
        element: <VariablesPage />,
      },
      {
        path: 'learning-paths',
        children: [
          { path: '', element: <LearningPathsPage /> },
          { path: 'create', element: <LearningPathBuilder /> },
          { path: ':id/edit', element: <LearningPathBuilder /> },
        ],
      },
      {
        path: 'cohorts',
        element: <CohortsPage />,
      },
      {
        path: 'tenant-config',
        children: [
          { path: '', element: <TenantConfigPage /> },
          { path: 'configure', element: <TenantConfigBuilder /> },
          { path: 'tabs', element: <TabsPage /> },
        ],
      },
      { path: 'change-password', element: <ChangePasswordPage /> },

      { path: '*', element: <NotFound /> },
    ],
  },
];

export const DEFAULT_PAGE = 'home';

export const soulmapRouteConfig = [
  {
    path: 'login',
    element: <LiftLoginPage />,
    isPublic: true,
  },
  {
    path: 'soulmap-login',
    element: <SoulMapLoginPage />,
    isPublic: true,
  },
  {
    path: 'soulmap',
    element: <Dashboard />,
    isPublic: false,
    children: [
      {
        path: '',
        element: <SoulMapHomePage />,
      },
      { path: ':id/run', element: <ChatPage /> },
    ],
  },
];

export const routeConfig = isSoulMapMode()
  ? soulmapRouteConfig
  : liftRouteConfig;
